module.exports = __webpack_public_path__ + "img/scene-bg-3.a23f57fc.png";